import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pendingRequests: {},
  underProcessRequests: {},
  completedRequests: {},
  manufacturePendingRequests: {},
  manufactureProcessingRequests: {},
  manufactureCompletedRequests: {},
  dashboard: {},
  refreshList: false,
};

const jewelleryInspectorSlice = createSlice({
  name: "inspector",
  initialState,
  reducers: {
    addInspector: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addManufactureRequests: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addDashboard: (state, action) => {
      const { data } = action.payload;
      state.dashboard = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default jewelleryInspectorSlice;
export const {
  addInspector,
  addManufactureRequests,
  addDashboard,
  isRefreshList,
} = jewelleryInspectorSlice.actions;
